<template>
<div class="myinfo_wrap">
    <div class="page_title_center">
       추천인 정보
        <div class="btn_group">
            <router-link to='/m/myinfo/recommender/reward' class="btn" :class="currentMode('m_MyInfo_Recommender_Reward')">리워드 내역</router-link> 
            <router-link to='/m/myinfo/recommender/list' class="btn" :class="currentMode('m_MyInfo_Recommender_List')">내 추천인들</router-link>            
        </div> 
    </div>   
    <div class="top_round_deco"></div>
    <router-view />

</div>
</template>
<script>
export default {
    name:'',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[

    ],
    components:{
        
    },
    mounted() {
    },
    methods:{
        currentMode(link)
        {
            if(this.$route.name === link)
            {
                return 'active'
            }else{
                return null
            }   

                 
        }    
    }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/mobile';
.btn_group{    
    margin-top:10px;
    display:flex;
    justify-content:center;  
    font-size:14px; 
    .btn:first-child{
        border-radius: .25rem;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right-width: 0;
    }
    .btn:last-child{
        border-radius: .25rem;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left-width: 0;
    }
    .btn{       
        padding: .4rem .5rem;        
        transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;
        transition-duration: .2s;
        transition-timing-function: cubic-bezier(.4,0,.2,1);
        border: 1px solid #234cad;      
        text-decoration:none;
        background-color: #363b7e;
        color:#7281bb;
    }
    .btn:hover, .active{
        --transform-scale-x: 1.1;
        --transform-scale-y: 1.1;  
        color: #000; 
        background-color: #fff;
        font-weight:Bold;
        
    }
}
</style>